// Agenda-uren alvast ophalen bij het openen van een Planning-tab (Joris, 26 sep: agenda
// van iedereen blijven laden, gedeeld met Rooster/Capaciteit, maar zo snel mogelijk).
//
// Het planbord (Nog in te plannen) vraagt standaard de huidige + volgende week. Door die
// aanvraag vooraf te doen staat de agenda al in de gedeelde planningCache als je een
// project openklapt. Zelfde sleutel als useRooster (agendaVenster/agendaMails komen hier
// vandaan), en `haal` hergebruikt een lopende aanvraag of een verse cache: nooit dubbel.
import { haalPersonen, haalAgenda } from './planningBronnen';
import { getMonday, formatDateISO, addDays } from './weekUtils';
import { gedeeldeEmails, leesOpslag } from '../pages/CapacityOverview/capaciteitPersonen';

/** Agendavenster ma t/m zo van `numWeken` weken vanaf `ws` (zelfde als Rooster/planbord). */
export const agendaVenster = (ws, n) => ({ startDate: formatDateISO(ws), endDate: formatDateISO(addDays(ws, n * 7 - 1)) });

/** Eigen mailboxen (kleine letters, uniek); gedeelde postbussen niet. */
export const agendaMails = (persons, gedeeld = gedeeldeEmails(persons)) => [...new Set((persons || [])
  .map((p) => String(p.email || '').trim().toLowerCase())
  .filter((e) => e && !gedeeld.has(e)))];

const VOORUIT_WEKEN = 2; // huidige + volgende week (standaard van het planbord)
const RUST_MS = 60 * 1000; // binnen een minuut niet nog eens proberen (tabwissels)
const laatste = new Map(); // `${account}|${venster}` → tijdstip

const geldigAantal = (ruw) => ([1, 2, 4].includes(Number(ruw)) ? Number(ruw) : undefined);

/**
 * Hoeveel weken het scherm op dit pad zelf opvraagt (zelfde opslag als dat scherm), zodat
 * de vooraf-lading dezelfde cachesleutel raakt: Capaciteit standaard 1 week, Rooster en
 * het planbord van Nog in te plannen standaard 2. Andere tabs: het planbord-venster.
 */
export function wekenVoorPad(pad) {
  if (pad === '/capacity') return leesOpslag('capaciteit:weken', 1, geldigAantal);
  if (pad === '/planner-todo') return leesOpslag('plannerWeken', 2, geldigAantal);
  return leesOpslag('inplannenWeken', VOORUIT_WEKEN, geldigAantal);
}

/**
 * De agenda (vanaf deze maandag, `weken` weken) alvast in de gedeelde cache zetten.
 * Hooguit één keer per minuut per account en venster; een lopende of verse aanvraag
 * wordt door `haal` hergebruikt. Stil: fouten tonen de schermen zelf als ze de agenda
 * echt nodig hebben.
 * @returns {Promise<void>}
 */
export function laadAgendaVooruit({ nu = new Date(), weken = VOORUIT_WEKEN, account = '' } = {}) {
  const venster = agendaVenster(getMonday(nu), weken);
  const sleutel = `${String(account || '').toLowerCase()}|${venster.startDate}|${venster.endDate}`;
  if (Date.now() - (laatste.get(sleutel) || 0) < RUST_MS) return Promise.resolve();
  laatste.set(sleutel, Date.now());
  return haalPersonen()
    .then((persons) => {
      const emails = agendaMails(persons);
      if (!emails.length) return undefined;
      return haalAgenda({ emails, ...venster });
    })
    .then(() => undefined)
    .catch(() => undefined);
}

/** Alleen voor tests. */
export const _resetAgendaVooruit = () => { laatste.clear(); };
